export default __webpack_public_path__ + "static/media/game_5_l.0516cc2f.png";